/* gestion des messages d'erreurs sur les champs DSFR */
export class DsfrErrorField {

    static collectionErrorFields = new Map();
    static hasError = false;

    constructor($jqInput, fieldName) {

        this.inputName = fieldName;
        this.$jqInput = $jqInput;
        this.onError = false;
    }

    static checkInputsWithError() {

        let hasError = false;
        $("#g6k_form [aria-invalid=true]").each(function (index) {
            $(this).trigger('focus');
            hasError = true;
            return false; //break loop
        });

        return hasError;
    }

    static onError(inputName) {

        let obj = DsfrErrorField.collectionErrorFields.get(inputName);

        if (!(obj instanceof DsfrErrorField)) {
            return false;
        }

        let ariaInvalid = obj.$jqInput.attr('aria-invalid');

        if(obj.onError){
            return true;
        }

        if (ariaInvalid == "true" ) {
            return true;
        }

        return false;
    }

    static setMsgError(inputName, message) {

        if (inputName == "") {
            throw new Exception("DSFRErrorField inputName non défini");
        }
        let obj = DsfrErrorField.collectionErrorFields.get(inputName);

        if (!(obj instanceof DsfrErrorField)) {

            let jqInput = $("*[name=" + inputName + "]");

            if (jqInput.length == 0) {
                jqInput = $("#" + inputName);
            }

            if (jqInput.lenght == 0) {
                throw new Exception('impossible de trouver le champ: ' + inputName);
            }

            obj = new DsfrErrorField(jqInput, inputName);
            DsfrErrorField.collectionErrorFields.set(inputName, obj);
        }

        obj.onError = true;
        obj._setErrorMessage(message);

    }

    static removeMsgError(inputName) {

        let obj = DsfrErrorField.collectionErrorFields.get(inputName);

        if (obj instanceof DsfrErrorField) {
            obj.onError = false;
            obj._setErrorMessage("");
            return;

        }
    }

    _setErrorMessage(message) {

        if (this.$jqInput.hasClass("fr-input")) {
            return DsfrErrorField.msgOnInput(this.$jqInput,message);
        }

        if (this.$jqInput.hasClass("fr-select")) {
            return DsfrErrorField.msgOnSelect(this.$jqInput,message);
        }

        if (this.$jqInput.is("fieldset")) {
            return DsfrErrorField.msgOnFieldset(this.$jqInput, message);
        }

        if (this.$jqInput.is(":radio")) {
            let fieldset = this.$jqInput.closest("fieldset");
            return DsfrErrorField.msgOnFieldset(fieldset, message);
        }

        console.log('setErrorMessage: champ non supporté, msg: ' + message);

    }

    // Passage du champs "input" en mode "error" si un message est renseigné
    // @$jqInput element Jquery 
    static msgOnInput($jqInput, message) {

        let $inputContainer = $jqInput.closest('.fr-input-group');
        let idError = $jqInput.attr('aria-describedby');
        let $pMsgError = $('#' + idError);

        $inputContainer.removeClass('fr-input-group--error');
        $jqInput.removeClass('fr-input--error');
        $jqInput.attr('aria-invalid', false); //attention au removeAttr('aria-describedby') dans g6k (removeError())
        $pMsgError.addClass('fr-hidden');
        $pMsgError.text("");

        if (message) {
            $inputContainer.addClass('fr-input-group--error');
            $jqInput.addClass('fr-input--error');
            $jqInput.attr('aria-invalid', true);
            $pMsgError.text(message);
            $pMsgError.removeClass('fr-hidden');
        }

    }

    // Passage du champs "select" en mode "error" si un message est renseigné
    // @$jqInput element Jquery 
    static msgOnSelect($jqInput, message) {

        let divSelect = $jqInput.closest('.fr-select-group');
        let idError = $jqInput.attr('aria-describedby');
        let $pMsgError = $('#' + idError);

        divSelect.removeClass('fr-select-group--error');
        $jqInput.removeClass('fr-select--error');
        $jqInput.attr('aria-invalid', false);
        $pMsgError.addClass('fr-hidden');
        $pMsgError.text("");

        if (message) {
            divSelect.addClass('fr-select-group--error');
            $jqInput.addClass('fr-select--error');
            $jqInput.attr('aria-invalid', true);
            $pMsgError.text(message);
            $pMsgError.removeClass('fr-hidden');
        }

    }

    // Passage du fieldset radio / checkbox en mode "error" si un message est renseigné
    // @$fieldset element Jquery 
    static msgOnFieldset($fieldset, message) {

        let idError = 'error-' + $fieldset.attr('id');
        let $pMsgError = $('#' + idError);

        $fieldset.removeClass('fr-fieldset--error');
        $fieldset.attr('aria-invalid', false);
        $pMsgError.addClass('fr-hidden');
        $pMsgError.text("");

        if (message) {
            $fieldset.addClass('fr-fieldset--error');
            $fieldset.attr('aria-invalid', true);
            $pMsgError.text(message);
            $pMsgError.removeClass('fr-hidden');
        }

    }

}